module.exports = __webpack_public_path__ + "img/btn_google.3cf64b08.svg";